import React, { useState } from 'react';
import { useEffect, useRef, useMemo } from "react";

// import './FloatingButton.css';
import logo from './img/bot.png'
// import agrandir from './img/agrandir.png'
// import reduire from './img/reduire.png'
import user from './img/user.png'
import admin from './img/admin.png'
// import refresh from './img/refresh-3.png'

import axios from "axios";
// import waitingText from "./img/load.webp"
// import loadHistory from "./img/loader-message.gif"
// import TimeSelector from "./components/TimeController"
// import ErrorComponent from "./components/Error"
import LangGlobe from './mui-components/LangGlobe';
import ChatFooter from './mui-components/ChatFooter';
import { Fab } from "@mui/material";

import {
	isValidPhoneNumber
} from 'react-phone-number-input'
// import MyPhoneInput from './MyPhoneInput'
// import MyPhoneInput from './components/MyPhoneInput'
import PlainPhoneInput from './mui-components/PlainPhoneInput'

// import Autocomplete from "react-google-autocomplete";
import Autocomplete from "./mui-components/Autocomplete";
// import SendIcon from './components/SendIcon';
import { getContrastColor, 
  // getContrastColorBackground 
} from './components/color';
import { GOOGLE_API_KEY, getApiBaseUrl } from './components/constant'
// import { translations, t } from './i18n';
import { t } from './i18n';
// import Typography from '@mui/material/Typography';
import {
  Box,
  Button,
  IconButton,
  Typography,
  Paper,
  TextField,
  Stack
} from "@mui/material";

import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import ChatMessage from './mui-components/ChatMessage'

// import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorComponent from "./mui-components/Error"



const RESET_TIME = 1 * 60 * 60 * 1000
// const initMessage = { content: t('initMessage', lang), role: "bot", status: 'in-progress', created_at: new Date(), lang: 'fr'}
// const initMessage = { content: "Salut je suis votre assistant virtuel, comment puis-je vous aider ?", role: "bot", status: 'in-progress', created_at: new Date(), lang: 'fr'}
const initMessage = { role: "bot", status: 'in-progress', created_at: new Date(), lang: 'fr'}


const FloatingChat = (props) => {
  const {
    // company_name,
    TCM_API_KEY, 
    height = "600px",
    width = "400px",
    dataPosition = "bottom-right",
    apiBaseUrl,
    // baseOnlinePage
    // pageLink 
  } = props

  const baseUrl =  getApiBaseUrl(apiBaseUrl);
  const fileInputRef = useRef(null);
  const [imageData, setImageData] = useState(null);
  
  const [isOpen, setIsOpen] = useState(false);
  const [endTime, setEndTime] = useState(new Date().getTime() + RESET_TIME);

  const [showButton, setShowButton] = useState(false);
  const [client, setClient] = useState({

  });
  const [company, setCompany] = useState(null)
  const headers = useMemo(() => ({
    'TCM_API_KEY': TCM_API_KEY,

  }), [TCM_API_KEY]);

  const [input, setInput] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  // const [rating, setRating] = useState("");
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");

  const [messages, setMessages] = useState([
    {...initMessage, content: t('initMessage', lang)},
  ]);

  const [errors, setErrors] = useState({ email: '', phone: '' });
  const [conversationId, setConversationId] = useState(null);
  const [errorBackend, setErrorBackend] = useState(false)

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const chatBodyRef = useRef(null);
  
  const [disabledInput, setDisabledInput] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleEvaluation = () => {
    setDisabledInput(true)
    var evalMessage = { content: t('ratingLabel'), role: "bot", status: 'in-progress', created_at: new Date(), lang: lang, type: "EVAL_MESSAGE"};
    setMessages(prev => [...prev, evalMessage]); // ✅ Don't use `messages` directly
  }

  useEffect(() => {
    // When isOpen becomes true and ref is available, scroll
    if (isOpen && chatBodyRef.current) {
      setTimeout(() => {
        if (chatBodyRef.current) {
          chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
      }, 50); // small delay to ensure DOM is painted
    }
  }, [isOpen]); // run this when modal opens


  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
    if(messages.length > 0){
      var lastMessage = messages[messages.length - 1]
      if (
        lastMessage.buttons !== undefined
        && lastMessage.buttons !== null
        && lastMessage.buttons.length > 0){
          if (lastMessage.buttons[0].type_button === "Button_choix"){
            setDisabledInput(true)
          }
          if (lastMessage.buttons[0].status === "End_Conversation"){
            setDisabledInput(true)
            // handleEvaluation()
              setDisabledInput(true)
              var evalMessage = { content: t('ratingLabel'), role: "bot", status: 'in-progress', created_at: new Date(), lang: lang, type: "EVAL_MESSAGE"};
              setMessages(prev => [...prev, evalMessage]); // ✅ Don't use `messages` directly
          }
      }
    }
  }, [messages, isLoading, lang]); // Triggers on new messages or loading indicator

    useEffect(() => {
      const savedLang = localStorage.getItem("lang");
      if (savedLang) setLang(savedLang);
    }, []);

  useEffect(() => {
    const local_conversation_id = getWithExpiry('conversation-id');
    const loadMessage = (id) => {
      if (id.trim() !== '') {
        axios.get(baseUrl + '/chat/history/'+id, { headers })
        .then((res) => {
            var data = res.data
            if (data.length !==0 ){
              axios.get(baseUrl + '/chat/last-chat-response', { headers, params: {conversation_id: id} })
                .then((message_resp) => {
                  var last_message = message_resp.data

                  if (last_message!=null && last_message?.buttons?.length !== 0 ){
                    data[data.length - 1].buttons = last_message.buttons
                  }
                  setMessages([{...initMessage, content: t('initMessage', lang)}, ...data])
                })
                .catch(err => {
                  console.log(err, 'an error')
                })
            }

            if (chatBodyRef.current) {
              chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
            }     
          })
        .catch((err) => {
          setConversationId(null)
        })
        .finally(() => {
          // setIsLoading(false); // End loading whether success or error
        });
      }
    }
    if(headers){
      axios.get(baseUrl + '/clients/get-client/', { headers})
        .then((res) => {
            var data = res.data 
            setCompany(data)

            axios.get(baseUrl + '/clients/config-chat/', { headers, params:{client_id: data.id}})
            .then((response) => {
              var config = response.data 
              if(config){
                setClient(config)
              }
              
              setShowButton(true)
              setIsOpen(true)
              if (chatBodyRef.current) {
                chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
              }   
            })
            .catch((err) => {
              console.log(err, "error check")
              setClient({})
            })
        }).catch((err) => {
          console.log(err)
          setShowButton(false)
        })
    }
    if (local_conversation_id) {
      setIsLoadingHistory(true)
      loadMessage(local_conversation_id); // Your custom function
      setConversationId(local_conversation_id)
      setErrorBackend(localStorage.getItem("has-error") === "true")
    }

  }, [headers, baseUrl, lang]);

  useEffect(() => {
    // if (validateEmail(email) && validatePhone(phone)){

    if (email !== "" || phone !== "") {
      if (validateEmail(email) && isValidPhoneNumber(phone)){
        setInput(phone + "," + email)
      } else if (email === ""){
        if(isValidPhoneNumber(phone)){
          setInput(phone+",")
        }else{
          setInput('')
        }
      }else if (phone.length <= 3){
        if (validateEmail(email)) {
          setInput(","+email)
        }else{
          setInput('')
        }
      }else{
        setInput('')
      }
    }else{
      setInput('')
    }
  }, [email, phone]); // Triggers on new messages or loading indicator

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  };

  function getWithExpiry(key) {
    const item = localStorage.getItem(key);
    
    if (!item) {
      return null;
    }

    const storedItem = JSON.parse(item);
    // console.log(Date.now(), storedItem.expiry, new Date(storedItem.expiry))
    if (Date.now() > storedItem.expiry) {
      console.log('should remove')
      localStorage.removeItem(key); // Remove expired item
      return null;
    }
    setEndTime(storedItem.expiry)
    return storedItem.value;
  }

  const formatDateForBackend = (date) => {
    const pad = (num, size = 2) => String(num).padStart(size, '0');

    const year = date.getUTCFullYear();
    const month = pad(date.getUTCMonth() + 1);
    const day = pad(date.getUTCDate());

    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());
    const seconds = pad(date.getUTCSeconds());

    // JS only has milliseconds (3 digits), backend wants 6 → add 000
    const microseconds = pad(date.getUTCMilliseconds(), 3) + "000";

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${microseconds}+00`;
  };

  const sendMessage = () => {
    var time_now = new Date().getTime()
    if(time_now > endTime){
      // console.log(time_now, endTime, 'we should reset everything')
      setMessages([{...initMessage, content: t('initMessage', lang)}])
      setConversationId(null)
      return
    }
    if (canSend ) {
      const userMessage = { content: input, role: "user", status: 'in-progress', created_at: new Date(), lang: lang, image_url: imageData !== null ? imageData.local_url : null};
      var lastMessage = {}
      if(messages.length !== 0){
       lastMessage = messages[messages.length - 1]
       if(lastMessage.type === "EVAL_MESSAGE"){
          userMessage.type = "EVAL_RESULT"
       }
      }

      setMessages(prev => [...prev, userMessage]); // ✅ Don't use `messages` directly
      setInput("");
      setIsLoading(true); // Start loading
      setDisabledInput(true)
      setErrorBackend(false)
      localStorage.setItem('has-error', "false")

      const date = new Date();
      // const formattedUTC = date.toISOString().split('.')[0] + 'Z';
      const formattedUTC = formatDateForBackend(date);

      var data = conversationId === null
      ? { message: input, date_msg_user : formattedUTC, lang: lang }
      : { message: input, conversation_id: conversationId, date_msg_user : formattedUTC, lang: lang };

      if(messages.length !== 0){
          // console.log(lastMessage.buttons)
        if(lastMessage.buttons && lastMessage?.buttons?.length !== 0){
            var lastItem = lastMessage.buttons[0]
            // console.log(lastItem, 'last item')
            if (lastItem.type_button !== "Button_aide"){
              data = { 
                conversation_id: conversationId,
                date_msg_user : formattedUTC,
                lang: lang,
                button: {
                  status: lastItem.status,
                  value: input,
                  date_msg_user : formattedUTC
                }
              }
            }
        }else if (lastMessage.type === "EVAL_MESSAGE"){
            data = { 
              conversation_id: conversationId,
              date_response_chatbot : formattedUTC,
              lang: lang,
              rating: input,
            }
            return axios.post(baseUrl + '/chat/send-rating', data, { headers })
                    .then((res) => {
                      // console.log(res)
                      // handleReset()
                        localStorage.removeItem("last-buttons")
                        localStorage.removeItem('slots-rdv')
                        localStorage.removeItem('conversation-id')
                        localStorage.removeItem("has-error")
                        setDisabledInput(false)
                        // setMessages([{...initMessage, content: t('initMessage', lang)}])
                        setErrorBackend(false)
                        setConversationId(null)
                    })
                    .catch((err) => {
                        console.log(err, 'llll')
                        handleReset()
                        // setMessages(prev => prev.slice(0, -1));
                        // setDisabledInput(true)
                        // setErrorBackend(true)
                        // setImageData(null)
                        // localStorage.setItem('has-error', "true")
                    })
                    .finally(() => {
                      setIsLoading(false); // End loading whether success or error
                    });
        }

      }
      const formData = new FormData();
      formData.append("chat_request", JSON.stringify(data));

      if(imageData){
        formData.append('image_file', imageData.file, imageData.file.name)
        setImageData(null)
      }
      axios.post(baseUrl + '/chat/', formData, { headers })
        .then((res) => {
            var response_data = res.data;

            response_data['role'] = 'bot'
            response_data['created_at'] = new Date()
            response_data['content'] = response_data.response
            setMessages(prev => [...prev, response_data]);
            setImageData(null)
            
            if (response_data.buttons){
              var lastItem = response_data.buttons[0]

              if (lastItem.type_button !== "Button_aide"){
                if (lastItem.status === "End_Conversation"){
                  // setConversationId(null)
                  setEmail("");
                  setPhone("");
                  setInput("");
                  // localStorage.removeItem('conversation-id')
                  handleEvaluation()
                  return 

                }else{
                  setConversationId(response_data.conversation_id)
                  const item = {
                    value: response_data.conversation_id,
                    expiry: new Date().getTime() + RESET_TIME // 10 hours
                  };
                  localStorage.setItem("conversation-id", JSON.stringify(item));
                  setEndTime(new Date().getTime() + RESET_TIME)
                }
              }else{
                setConversationId(response_data.conversation_id)
                const item = {
                  value: response_data.conversation_id,
                  expiry: new Date().getTime() + RESET_TIME // 10 hours
                };
                localStorage.setItem("conversation-id", JSON.stringify(item));
                setEndTime(new Date().getTime() + RESET_TIME)
              }
            }else{
              localStorage.setItem("last-buttons", JSON.stringify([]));
              setConversationId(response_data.conversation_id)
              const item = {
                value: response_data.conversation_id,
                expiry: new Date().getTime() + RESET_TIME // 10 hours
              };
              localStorage.setItem("conversation-id", JSON.stringify(item));
              setEndTime(new Date().getTime() + RESET_TIME)
            }

            setDisabledInput(false)
            if (chatBodyRef.current) {
              chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
            }
        })
        .catch((err) => {
            setMessages(prev => prev.slice(0, -1));
            setDisabledInput(true)
            setErrorBackend(true)
            setImageData(null)
            localStorage.setItem('has-error', "true")
        })
        .finally(() => {
          setIsLoading(false); // End loading whether success or error
        });
    }else{
      // console.log('still processing the previous message')
    }
  };

  function formatDate(date) {
    const d = new Date(date);
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const seconds = d.getSeconds().toString().padStart(2, '0');
    
    return `${d.getDate().toString().padStart(2, '0')}/${
      (d.getMonth() + 1).toString().padStart(2, '0')
    }/${d.getFullYear()} ${hours}:${minutes}:${seconds}`;
  }

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setErrors((prev) => ({
      ...prev,
      email: validateEmail(value) ? '' : 'Invalid email address',
    }));
  };

  const handlePhoneChange = (value) => {
    if (value !== undefined){
      setPhone(value);
      if(value.length >= 3){
        setErrors((prev) => ({
          ...prev,
          phone: isValidPhoneNumber(value) ? '' : 'Invalid phone number',
        }));
      }
    }
  };

  function trimCommas(str) {
    return str.replace(/^,|,$/g, '');
  }

  const handleReset = ()=> {
    localStorage.removeItem("last-buttons")
    localStorage.removeItem('slots-rdv')
    localStorage.removeItem('conversation-id')
    localStorage.removeItem("has-error")
    setDisabledInput(false)
    setMessages([{...initMessage, content: t('initMessage', lang)}])
    setErrorBackend(false)
    setConversationId(null)
  }

  const openFilePicker = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFile(file)
    }
    e.target.value = null;
  };

  const handleDrop = (e) => {
    e.preventDefault();

    const file = e.dataTransfer.files[0];

    if (file && file.type.startsWith("image/")) {
      handleFile(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handlePaste = (e) => {
    const items = e.clipboardData.items;

    for (let item of items) {
      if (item.type.startsWith("image")) {
        e.preventDefault(); // stop text/file name from appearing in textarea

        const file = item.getAsFile();
        handleFile(file); // your existing upload logic
        return;
      }
    }
  };

  const handleFile = (file) => {
    console.log("Image dropped:", file);

    const imageUrl = URL.createObjectURL(file);
    setImageData(prev => ({
      file: file,
      local_url: imageUrl
    }))
  };
  const handleChangeLanguage = (langage) => {
    localStorage.setItem("lang", langage)
    setLang(langage)
    if(messages.length === 1){
      setMessages(([
        {...initMessage, content: t('initMessage', langage)},
      ]))
    }
  }
  const canSend = (input.trim() || imageData !== null ) && !isLoading


  return (
    <>
        {!isOpen && showButton && (
          <Box
              sx={{
                  position: "fixed",
                  bottom: 20,
                  ...(dataPosition === "bottom-right"
                      ? { right: 20 }
                      : { left: 20 }),
                  display: "flex",
                  flexDirection: "column", // 🔥 THIS
                  alignItems: "center",
                  gap: 1
              }}
          >
              <Typography variant="body2">
                {t("help", lang)}
              </Typography>


              <Fab color="primary" onClick={toggleChat}>
                <Box component="img" src={client.floating_button_icon_url || logo} sx={{ width: 24, borderRadius: 8 }} />
              </Fab>

          </Box>
        )}

        {isOpen && (
          <Paper
              elevation={6}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              // onDrop={handleDrop}
              sx={{
                position: "fixed",
                bottom: 20,
                width: width,
                height: height,
                maxWidth: "90%",
                maxHeight: "80vh",
                display: "flex",
                flexDirection: "column",
                borderRadius: 3,
                bgcolor: client.background_color || "#fff",
                overflow: "hidden", // IMPORTANT
                ...(dataPosition === "bottom-right"
                    ? { right: 15 }
                    : { left: 15 }),
              }}
          >
              <Box
                sx={{
                  bgcolor: client.header_color || "#cac39c",
                  p: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexShrink: 0 // 🔥 prevents shrinking
                }}
              >
                  <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
                      <Box
                      component="img"
                      src={client.logo_url}
                      sx={{ width: 30, height: 30 }}
                      />

                      <Typography variant="subtitle2">
                        CHATBOT {company?.name?.toUpperCase()}
                      </Typography>
                  </Stack>

                  <Stack direction="row" spacing={0}>
                      <IconButton onClick={toggleChat}>−</IconButton>
                      <LangGlobe lang={lang} setLang={setLang} handleChangeLanguage={handleChangeLanguage} client={client} />
                  </Stack>
              </Box>

              <Box
                sx={{
                  flex: 1,              // 🔥 takes all remaining space
                  overflowY: "auto",    // 🔥 scroll only here
                  px: 1,
                  py: 2,
                }}
                ref={chatBodyRef}
              >
                  {messages.map((msg, i) => (
                    <ChatMessage
                      key={i}
                      t={t}
                      lang={lang}
                      msg={msg}
                      largeText={false}
                      input={input}
                      setInput={setInput}
                      isLast={i === messages.length - 1}
                      client={client}
                      userAvatar={user}
                      botAvatar={admin}
                      formatDate={formatDate}
                      trimCommas={trimCommas}
                      handleReset={handleReset}
                      isLoading={isLoading}
                      isLoadingHistory={isLoadingHistory}
                      errorBackend={errorBackend}
                      // setRating={setRating}
                      // rating={rating}
                      onChange={(val) => {
                          setInput(val)
                          setDisabledInput(true)
                      }}
                    />
                  ))}

                  {errorBackend ? (
                    <ErrorComponent client={client} handleReset={handleReset} company={company} lang={lang} t={t}/>
                  ): null}

              </Box>


          {messages.length > 0 &&
            messages[messages.length - 1]?.buttons?.length > 0 &&
            messages[messages.length - 1]?.buttons[0]?.type_button === "Button_aide" &&
            !isLoading && (
              
              <Box
                sx={{
                  // borderTop: `1px solid ${client.line_color || "#adb5bd"}`,
                  p: 1
                }}
              >
                <Stack
                  direction="column"
                  spacing={1}
                  useFlexGap
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    
                  }}
                >
                  {messages[messages.length - 1].buttons.map((item, index) =>
                    item.type_button === "Button_aide"
                      ? item.value.slice(0, 3).map((val, j) => (
                          <Button
                            key={j}
                            variant="contained"
                            size="small"
                            onClick={() => setInput(val)}
                            sx={{
                              bgcolor: client.help_button_color || "#98ceA1",
                              color: getContrastColor(
                                client.help_button_color || "#98ceA1"
                              ),
                              textTransform: "none",
                              fontSize: "0.75rem",
                              minWidth: 270,
                              borderRadius: 5,
                              "&:hover": {
                                opacity: 0.9
                              }
                            }}
                          >
                            {val}
                          </Button>
                        ))
                      : null
                  )}
                </Stack>
              </Box>
          )}

          {
            imageData && (
              <Box
                sx={{
                  borderTop: `1px solid ${client.line_color || "#adb5bd"}`,
                  display: "flex",
                  justifyContent: "center",
                  p: 1,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  {/* DELETE BUTTON */}
                  <IconButton
                    size="small"
                    onClick={() => setImageData(null)}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      bgcolor: "rgba(0,0,0,0.6)",
                      color: "#fff",
                      "&:hover": {
                        bgcolor: "rgba(0,0,0,0.8)",
                      },
                      width: 22,
                      height: 22,
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 14 }} />
                  </IconButton>

                  {/* IMAGE */}
                  <Box
                    component="img"
                    src={imageData.local_url}
                    alt="preview"
                    sx={{
                      height: 85,
                      width: 85,
                      borderRadius: 2,
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Box>
            )
          }

          <Box
            sx={{
              flexShrink: 0, // 🔥 fixed at bottom
              borderTop: `1px solid ${client.line_color || "#ddd"}`,
              p: 1,
            }}
          >

              {messages.length > 0 
              && messages[messages.length - 1]?.buttons !== undefined 
              && messages[messages.length - 1]?.buttons !== null 
              && messages[messages.length - 1]?.buttons?.length !== 0 
              && !isLoading 
              && messages[messages.length - 1]?.buttons[0]?.status === 'Txt_contact' ?
                  (
                    <>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        width: "100%",
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                        {/* EMAIL */}
                        <Box sx={{ flex: 1 }}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="email"
                            variant="outlined"
                            onChange={handleEmailChange}
                            // error={!!errors.email}
                            // helperText={errors.email}
                            sx={{
                              bgcolor: client.chatbot_place_holder || "#fff",
                              "& input": {
                                // color: client.chatbot_place_holder || "inherit",
                                fontSize: "14px",
                              },
                            }}
                          />
                        </Box>

                        {/* PHONE */}
                        <Box sx={{ flex: 1 }}>
                          <Box
                            sx={{
                              backgroundColor: client.chatbot_place_holder || "#fff",
                              borderRadius: 1,
                              // borderRadius: "12px",
                              p:0,
                              // px: 1,
                              // py: 0.5,
                              border: errors.phone ? "1px solid red" : "1px solid #ccc",
                            }}
                          >
                            <PlainPhoneInput
                              international
                              value={phone}
                              t={t}
                              onChange={handlePhoneChange}
                            />
                          </Box>
                        </Box>
                        <IconButton
                        onClick={sendMessage}
                        disabled={!canSend}
                        size='small'
                        sx={{
                            color: client.send_button_color || "#0bECAe",
                        }}
                      >
                        <SendIcon />
                      </IconButton>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        width: "100%",
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                          {errors.phone && (
                            <Typography sx={{ color: "red", fontSize: 10, mt: 0.5 }}>
                              {errors.phone} {errors.phone && errors.email ? "," : null}
                            </Typography>
                          )}
                          
                          {errors.email && (
                            <Typography sx={{ color: "red", fontSize: 10, mt: 0.5 }}>
                              
                              {errors.email}
                            </Typography>
                          )}
                    </Box>
                    </>
              ) : 
              messages.length > 0 
              && messages[messages.length - 1]?.buttons !== undefined 
              && messages[messages.length - 1]?.buttons !== null 
              && messages[messages.length - 1]?.buttons?.length !== 0 
              && !isLoading 
              && messages[messages.length - 1]?.buttons[0]?.status === 'Txt_adress' ?
              (
                <Box sx={{ p: 1 }}>
                  <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
                  <Autocomplete
                    apiKey={GOOGLE_API_KEY}
                    onPlaceSelected={(place) => {
                      if (place !== null){
                        console.log(place, 'oooo')
                        setInput(place.full_address)
                      }else{
                        setInput("")
                      }
                    }}
                    backgroundColor={client.chatbot_place_holder || "#fff"}
                    color={client.input_message_color || "#000"}
                    options={{
                      types: ["address"],
                    }}
                    placeholder={t("enterAddress", lang)}
                    className="chat-input" 
                  />

                  <IconButton
                      onClick={sendMessage}
                      disabled={!canSend}
                        sx={{
                            color: client.send_button_color || "#0bECAe",
                            // color: "#fff",
                            // "&:hover": {
                            //   bgcolor: client.send_button_color || "#0bECAe",
                            // },
                        }}
                    >
                      <SendIcon />
                    </IconButton>
                  </Stack>
                </Box>

              ) : 
              (
                <Box sx={{ p: 1,}}>
                  <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
                      
                      {!disabledInput && (
                        <IconButton onClick={openFilePicker} disabled={disabledInput}>
                            <AddIcon />
                        </IconButton>
                      )}

                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />

                      <TextField
                        fullWidth
                        multiline
                        minRows={1}
                        maxRows={2}
                        disabled={disabledInput}
                        placeholder={t("placeholder", lang)}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onPaste={handlePaste}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              sendMessage();
                            }
                        }}
                        size="small"
                      />

                      <IconButton
                        onClick={sendMessage}
                        disabled={!canSend}
                        sx={{
                            color: client.send_button_color || "#0bECAe",
                            // color: "#fff",
                            // "&:hover": {
                            //   bgcolor: client.send_button_color || "#0bECAe",
                            // },
                        }}
                      >
                        <SendIcon />
                      </IconButton>
                  </Stack>
                </Box>
              )}

            </Box>
            <ChatFooter t={t} client={client} baseUrl={baseUrl} lang={lang}/>

          </Paper>
        )}
    </>
  );
};

export default FloatingChat;
